import { render } from "./PurchaseProofNotification.vue?vue&type=template&id=15138b7e&scoped=true"
import script from "./PurchaseProofNotification.vue?vue&type=script&lang=js"
export * from "./PurchaseProofNotification.vue?vue&type=script&lang=js"

import "./PurchaseProofNotification.vue?vue&type=style&index=0&id=15138b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15138b7e"]])

export default __exports__